import * as React from 'react';
import { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import module from '../css/moduleStyle.module.css';
import styles from '../css/trfSfty.module.css';
import { useLocation } from 'react-router-dom';
import { SwItsGetEvntOneDetailProvider, SwItsGetEvntOneDetailInfo, SwItsGetEvntOneDetailEvnt, SwItsGetEvntOneDetailStatistics, SwItsGetEvntOneDetailCounter , SwItsGetEvntOneDetailCctvCapture , SwItsGetEvntOneDetailChart , SwItsGetEvntOneDetailCrsrdName } from 'pages/components/dashboard/SwItsGetEvntCrsrdFromId';
import { useSearchParams } from 'react-router-dom';
import { IconLabelBackButtons } from '../../components/button';
import { useNavigate } from 'react-router-dom';
import { useDashboard } from 'pages/components/DashboardContext';
import useNavigation from 'pages/components/UseNavigation';
export default function TrafficSafetyViewM() {
  const [params] = useSearchParams();
  const crsrdId = params.get('crsrdId');
  
  useEffect(() => {
    if (!crsrdId) {
    }
  }, [crsrdId]);

  const [activeId, setActiveId] = useState('전체');

  const { mapMessages, clearLastMapMessage } = useDashboard(); 
    
  
    console.log('mapMessages :::', mapMessages)
    useNavigation(mapMessages);

    useEffect(() => {
        if (mapMessages.length > 0) {
          clearLastMapMessage(); 
        }
      }, [mapMessages]); 


  return (
    <Box sx={{ height: '100%', width: '100%' }}>
      <SwItsGetEvntOneDetailProvider crsrdId={crsrdId}>
        <div className="container">
          <div className={`${module.gap60} contWrap L_lr`}>
            {/* 교차로 별 위험행동 통계 및 방안 */}
            <div className="inner L_s">
              <div className="titWrap flx a_center j_spc_btw">
                <SwItsGetEvntOneDetailCrsrdName/>
                <IconLabelBackButtons/>
              </div>
              <div className={`${module.gap60} flx flx_col boxCont`}>
                <div className={`${module.gap40} flx flx_col flx_1`} style={{height:'100%'}}>
                  <SwItsGetEvntOneDetailCounter activeId={activeId} />
                  <SwItsGetEvntOneDetailInfo />
                </div>
              </div>
            </div>

            {/* 교차로 위험행동 통계 */}
            <div className={`${module.gap20} flx flx_col inner L_l`}>
              <div className="titWrap flx a_center j_spc_btw">
                <h2 className="boxTit">돌발 위험상황 통계</h2>
              </div>
              <div className={`${styles.dangerStats} ${module.gap60} flx`}>
                <div className={`flx ${module.gap40}`}>
                  {/* 교차로 위험행동  */}
                  <div className={`flx flx_col ${module.gap40}`} style={{height:'100%'}}>
                    <SwItsGetEvntOneDetailEvnt activeId={activeId} setActiveId={setActiveId} />
                  </div>

                  <div className={`${module.gap40} flx flx_col`} style={{height:'100%'}}>
                    {/* 위험행동 통계  */}
                    <div className={`${module.gap20} flx flx_col`}>
                      {/* <h3 className={`${module.subTitle}`}>위험행동 통계</h3> */}
                      <SwItsGetEvntOneDetailStatistics />
                    </div>

                    {/* 최근 1년 위험행동 */}
                    <div className={`flx flx_col ${module.gap40} flx flx_col`} style={{height:'100%'}}>
                      <h3 className={`${module.subTitle}`}>최근 1년 위험행동 발생 건수</h3>
                      <div className={`${styles.oneYchart}`}>
                      <SwItsGetEvntOneDetailChart activeId = {activeId}/>
                      </div>
                    </div>
                    <div>
                    </div>
                  </div>
                </div>
                <SwItsGetEvntOneDetailCctvCapture activeId={activeId}/>
              </div>
            </div>
          </div>
        </div>
      </SwItsGetEvntOneDetailProvider>
    </Box>
  );
}


